module.exports = __webpack_public_path__ + "static/media/icon_ai-assistant-data-sphere.f7c1a449.svg";